export enum QueryType {
    BW = 'BW',
    Databricks = 'Databricks',
}
